import { render } from "./PriceMwstCheckbox.vue?vue&type=template&id=24f124e2"
import script from "./PriceMwstCheckbox.vue?vue&type=script&lang=js"
export * from "./PriceMwstCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__